class SpacesComponent extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('.spaces__grid');
    this.sortSelect = this.querySelector('.spaces__sort');
    this.categorySelect = this.querySelector('.spaces__category-filter');
    this.noResults = this.querySelector('.spaces__no-results');
    this.activeColor = null;
    this.activeCategory = '';

    this.addEventListener('click', this.onClick.bind(this));

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => this.sortBy(this.sortSelect.value));
    }

    if (this.categorySelect) {
      this.categorySelect.addEventListener('change', () => {
        this.activeCategory = this.categorySelect.value;
        this.applyFilters();
      });
    }
  }

  get items() {
    return Array.from(this.grid.querySelectorAll('.spaces__card-item'));
  }

  onClick(event) {
    const pill = event.target.closest('.spaces__color-pill');
    if (pill) this.toggleColor(pill);
  }

  sortBy(criterion) {
    const items = this.items;

    if (criterion === 'name') {
      items.sort((a, b) => a.dataset.name.localeCompare(b.dataset.name));
    } else if (criterion === 'price-asc') {
      items.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
    } else if (criterion === 'price-desc') {
      items.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
    } else {
      items.sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index));
    }

    items.forEach((item) => this.grid.appendChild(item));
  }

  toggleColor(pill) {
    const color = pill.dataset.color;
    const wasActive = pill.getAttribute('aria-pressed') === 'true';

    this.querySelectorAll('.spaces__color-pill').forEach((p) => p.setAttribute('aria-pressed', 'false'));

    if (wasActive) {
      this.activeColor = null;
    } else {
      pill.setAttribute('aria-pressed', 'true');
      this.activeColor = color;
    }

    this.applyFilters();
  }

  applyFilters() {
    let visibleCount = 0;

    this.items.forEach((item) => {
      const colors = (item.dataset.colors || '').split(',');
      const matchesColor = !this.activeColor || colors.includes(this.activeColor);
      const matchesCategory = !this.activeCategory || item.dataset.category === this.activeCategory;
      const isVisible = matchesColor && matchesCategory;
      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (this.noResults) this.noResults.hidden = visibleCount > 0;
  }
}

customElements.define('spaces-component', SpacesComponent);

class SpaceBuyBar extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('.spaces__buy-button');
      if (button) this.addSpaceToCart(button);
    });
  }

  addSpaceToCart(button) {
    const ids = (button.dataset.variantIds || '').split(',').filter(Boolean);
    if (ids.length === 0 || button.classList.contains('loading')) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items: ids.map((id) => ({ id: Number(id), quantity: 1 })) };

    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    const spinner = button.querySelector('.loading__spinner');

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    if (spinner) spinner.classList.remove('hidden');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description || response.message);
          return;
        }
        if (cart) {
          cart.renderContents(response);
          cart.classList.remove('is-empty');
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }
}

customElements.define('space-buy-bar', SpaceBuyBar);
